"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GDFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_81)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_81`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.28003 0H30.72V24H-5.28003V0Z",
					fill: "#C60A0A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.72 11.9789L-2.15723 20.8281V3.1228L12.72 11.9789Z",
					fill: "#3E8446"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.72 11.9789L27.527 20.8281H-2.15723L12.72 11.9789ZM27.527 3.1228L12.72 11.9789L-2.15723 3.1228H27.527Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M27.527 3.1228V20.8281L12.72 11.9789L27.527 3.1228Z",
					fill: "#3E8446"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.7199 0.729858L12.9164 1.44565H13.6673L13.0638 1.88775L13.2954 2.60354L12.7199 2.16144L12.0743 2.60354L12.3059 1.88775L11.7024 1.44565H12.4533L12.7199 0.729858ZM6.65677 0.729858L6.88835 1.44565H7.63923L7.03572 1.88775L7.2673 2.60354L6.65677 2.16144L6.04625 2.60354L6.27782 1.88775L5.67432 1.44565H6.42519L6.65677 0.729858ZM18.7129 0.729858L18.9445 1.44565H19.7024L19.0919 1.88775L19.3234 2.60354L18.7129 2.16144L18.1024 2.60354L18.334 1.88775L17.7305 1.44565H18.4813L18.7129 0.729858ZM12.7199 21.3474L12.9164 22.0632H13.6673L13.0638 22.5053L13.2954 23.2211L12.7199 22.779L12.0743 23.2211L12.3059 22.5053L11.7024 22.0632H12.4533L12.7199 21.3474ZM6.65677 21.3474L6.88835 22.0632H7.63923L7.03572 22.5053L7.2673 23.2211L6.65677 22.779L6.04625 23.2211L6.27782 22.5053L5.67432 22.0632H6.42519L6.65677 21.3474ZM18.7129 21.3474L18.9445 22.0632H19.7024L19.0919 22.5053L19.3234 23.2211L18.7129 22.779L18.1024 23.2211L18.334 22.5053L17.7305 22.0632H18.4813L18.7129 21.3474Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.8779 17.3263C14.8312 17.3263 17.2253 14.9322 17.2253 11.979C17.2253 9.02569 14.8312 6.63159 11.8779 6.63159C8.92462 6.63159 6.53052 9.02569 6.53052 11.979C6.53052 14.9322 8.92462 17.3263 11.8779 17.3263Z",
					fill: "#C60A0A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.8779 7.72632L12.8323 10.6597H15.9201L13.4218 12.4702L14.3762 15.4035L11.8779 13.593L9.38672 15.4035L10.3411 12.4702L7.84286 10.6597H10.9306L11.8779 7.72632ZM2.27795 11.7754C2.58672 12.2597 2.43935 12.9053 1.95514 13.214C1.47093 13.5228 0.825318 13.3754 0.516546 12.8912C-0.0378402 12.014 0.284967 10.5754 0.284967 10.5754C0.284967 10.5754 1.71655 10.8982 2.27795 11.7754Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.67433 13.2982C1.96113 13.2982 2.19363 13.0657 2.19363 12.7789C2.19363 12.4921 1.96113 12.2596 1.67433 12.2596C1.38753 12.2596 1.15503 12.4921 1.15503 12.7789C1.15503 13.0657 1.38753 13.2982 1.67433 13.2982Z",
					fill: "#A2001D"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_81`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GDFlag };
